import { useTranslation } from 'react-i18next';
import React, { useEffect, useState, useRef } from 'react';
import isEqual from 'react-fast-compare';

import { Select, MenuItem, ListSubheader, TextField, InputAdornment } from '@material-ui/core';

import { multiSelectStrings } from '../../../Functions/utils';
// import { getGroups } from '../../../Functions/reporting';
import { update } from '../../../Functions/admin';

import { useRealtimeContext } from '../../../Context/Realtime/Provider';

import './GroupSelect.css';


export default function GroupSelect({ onChangeGroups }) {
  const { t } = useTranslation();

  const loading = false;
  const [{ pickers, selected }, dispatch] = useRealtimeContext(); // reporting context

  const [savedSelectedGroups, setSavedSelectedGroups] = useState(selected.groups);
  const [groupsOpen, setGroupsOpen] = useState(false);
  const [searchText, setSearchText] = useState("");

  const setGroups = (groups) => {
    dispatch({
      pickers: {
        ...pickers,
        groups: groups
      },
      selected: {
        ...selected
      }
    });
  }

  const setSelectedGroups = (groups) => {
    dispatch({
      pickers: {
        ...pickers,
      },
      selected: {
        ...selected,
        groups: groups
      }
    });
  }

  const handleSelectGroup = (e, group) => {
    e.preventDefault();
    const newSelectedGroups = selected.groups.filter((grp) => grp.value !== group.value);

    if (newSelectedGroups.length === selected.groups.length)
      newSelectedGroups.push(group)

    setSelectedGroups(newSelectedGroups);
  }


  const handleUpdateFavorite = (e, group) => {
    e.preventDefault();

    const favorite = { groupId: group };
    let tmpArray = [];
    for (const grp of pickers.groups) {
      const tmpGrp = {
        ...grp
      }
      if (grp.value == group) {
        if (grp.favoriteId)
          tmpGrp.favoriteId = null;
        else
          tmpGrp.favoriteId = 'fake';
      }
      tmpArray.push(tmpGrp);
    }
    setGroups(tmpArray);

    try {
      update({ type: 'favorite', favorite }).then(res => {
        // console.log("82 - res=", res);

      });
    }
    catch (error) {
      console.log("681 - error=", error);
    }
  };

  let groupsName = '';
  let allSelected = false;

  if (selected.groups) {
    groupsName = selected.groups.map(grp => grp.label).join(', ');
  }

  if (pickers.groups && selected.groups) {
    allSelected = pickers.groups.length === selected.groups.length
  }

  const values = [];
  for (const grp of selected.groups) {
    values.push(grp.label);
  }

  // console.log("106 - pickers.groups=", pickers.groups);


  return (
    <Select className="sidebar__select"
      style={{
        display: "flex",

        width: '100%',
        height: '34px',
        padding: '0 8px',
        maxWidth: '1000%',
        outline: '0',
        // cursor: 'pointer',
        fontSize: '15px',
        fontWeight: '600',
        fontFamily: 'inherit',

        transition: '0.25s',
        color: 'rgb(var(--accent-color))',
        borderRadius: 'var(--radius-small)',
        backgroundColor: 'var(--select-bg)',
        border: '0 px solid var(--separation-color-light)',

        opacity: (loading || (pickers.groups && pickers.groups.length === 0)) ? '0.4' : '1',
        cursor: (loading || (pickers.groups && pickers.groups.length === 0)) ? 'not-allowed' : 'pointer'
      }}

      id='group_selecter'
      variant='outlined'
      multiple
      displayEmpty

      title={groupsName}

      open={groupsOpen}

      onClose={() => {
        setGroupsOpen(false);

        let newGroups = selected.groups.filter(x => {
          const found = savedSelectedGroups.find((element) => {
            return (element.value === x.value);
          });
          return !found
        });

        if (onChangeGroups && !isEqual(savedSelectedGroups, selected.groups)) {
          onChangeGroups(selected.groups, newGroups);
          setSavedSelectedGroups(selected.groups)
        }
      }}
      onOpen={() => {
        setSearchText('');
        setGroupsOpen(true)
      }}

      labelWidth={0}
      value={values}
      onChange={e => {
      }}

      renderValue={value => {

        if (value.length === 0) {
          return (
            <span
              style={{
                width: "100%",
                maxWidth: "100%",
                textAlign: 'left',
                fontSize: '15px', fontWeight: '500',
                //fontFamily: "'Open Sans', -apple-system, BlinkMacSystemFont, system-ui, sans-serif",
                transition: '0.25s',
                color: 'rgb(var(--accent-color))',

              }}>{multiSelectStrings(t, 'grp').selectSomeItems}
            </span>
          )
        }
        return (
          <div
            style={{ width: "90%", display: 'flex' }}
          >
            <span
              style={{
                width: "94%",
                maxWidth: "94%",
                textAlign: 'left',
                fontSize: '15px', fontWeight: '500',
                fontFamily: "'Open Sans', -apple-system, BlinkMacSystemFont, system-ui, sans-serif",
                transition: '0.25s',
                color: 'rgb(var(--accent-color))',
                overflow: 'hidden',
                textOverflow: 'ellipsis'

              }}>{groupsName}
            </span>
          </div>

        )
      }}
    >
      <ListSubheader id="group_selecter_search">
        <TextField
          size="small"
          autoFocus
          placeholder={multiSelectStrings(t, 'grp').search}
          fullWidth
          InputProps={{
            startAdornment: <InputAdornment position="start">
              <span
                style={{
                  fontSize: '20px',
                }}
                className="material-icons-outlined">search</span>
            </InputAdornment>
          }}
          onChange={(e) => setSearchText(e.target.value)}
          onKeyDown={(e) => {
            if (e.key !== "Escape") {
              e.stopPropagation();
            }
          }}
        />
      </ListSubheader>

      <MenuItem value="choose" style={{ display: 'none' }}>
        {''}
      </MenuItem>

      <MenuItem
        value={"all"}

        style={{
          paddingLeft: '6px',
          paddingRight: '20px',
          lineHeight: '20px',
          display: 'flex'
        }}

        onClick={(e) => {
          e.stopPropagation();
          if (allSelected)
            setSelectedGroups([]);
          else
            setSelectedGroups(pickers.groups);
        }}
      >
        <span
          className={"material-icons"}
          // title={t('global.checked')}
          style={{
            textAlign: 'left',
            width: '8%',
            fontSize: '16px',
            color: allSelected ? 'rgb(var(--favorite-color))' : 'initial'
          }}
        >
          {allSelected ? 'check_box' : 'check_box_outline_blank'}
        </span>

        <span
          style={{
            padding: '0 4px',
            width: "92%",
            maxWidth: "100%",
            textAlign: 'left',
            fontSize: '14px', fontWeight: '400', fontFamily: "'Open Sans', -apple-system, BlinkMacSystemFont, system-ui, sans-serif",
            transition: '0.25s',
            color: 'grey'
          }}
        >{multiSelectStrings(t, 'grp').selectAll}
        </span>
      </MenuItem >


      {pickers.groups && pickers.groups.length > 0 ? (
        pickers.groups.sort(function (a, b) {
          if (a.label.toLowerCase() < b.label.toLowerCase()) {
            return -1;
          }
          if (b.label.toLowerCase() < a.label.toLowerCase()) {
            return 1;
          }
          return 0;
        }).map((group, key) => {

          const isSelected = selected.groups.find((element) => {
            return (element.value === group.value);
          });
          const isDisplayed = (group.label.toLowerCase().indexOf(searchText.toLowerCase()) > -1);

          return (
            <MenuItem
              value={group.id}
              name={group.label}

              style={{
                paddingLeft: '6px',
                paddingRight: '20px',
                lineHeight: '20x',
                display: (isDisplayed || isSelected) ? 'flex' : 'none'
              }}

              onClick={(e) => {
                e.stopPropagation();
                handleSelectGroup(e, group)
              }}
            >
              <span
                className={"material-icons"}
                // title={t('global.checked')}
                style={{
                  textAlign: 'left',
                  width: '8%',
                  fontSize: '16px',
                  color: isSelected !== undefined ? 'rgb(var(--favorite-color))' : 'initial'
                }}
              >
                {isSelected !== undefined ? 'check_box' : 'check_box_outline_blank'}
              </span>

              <span
                style={{
                  padding: '0 4px',
                  width: "84%",
                  maxWidth: "100%",
                  textAlign: 'left',
                  fontSize: '14px', fontWeight: '400', fontFamily: "'Open Sans', -apple-system, BlinkMacSystemFont, system-ui, sans-serif",
                  transition: '0.25s',
                }}
              >{group.label}
              </span>              
            </MenuItem >
          )
        }
        )

      ) : (
        <div>
        </div>
      )}
    </Select>);
}
